import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { PayloadCreate, WebhookType } from './interfaces';
import { createStructuredSelector } from 'reselect';
import { Store } from '../../redux/reducers';
import { makeSelectError, makeSelectLoading } from './selectors';
import { createWebhooksActions } from './actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import AuthContext from '../../authContext';
import { translate } from '../../utils/helpers';
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiCardAccountDetailsOutline,
  mdiFormatListBulletedType,
  mdiPencil,
  mdiPlus,
  mdiSearchWeb,
  mdiWeb,
} from '@mdi/js';
import { useHistory } from 'react-router-dom';
import theme from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
    },
    cardContentOrder: {
      padding: '20px',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginTop: '24px',
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
  })
);

export type Props = {
  createWebhooksDispatch: (payload: PayloadCreate) => void;
  loading: boolean;
};

export type SelectorProps = {
  loading: boolean;
  error: '';
};

function WebhookComponent(props: Props) {
  const history = useHistory();
  const classes = useStyles();
  const [status, setStatus] = useState('SUSPENDED');
  const [serviceUrl, setServiceUrl] = useState('');
  const [webhookType, setWebhookType] = useState<any>('' as WebhookType);

  const webhookTypes = ['UPDATE_ORDER_STATUS', 'UPDATE_PARCEL_STATUS', 'INVENTORY_CHANGE'];

  const createWebhook = () => {
    props.createWebhooksDispatch({
      body: {
        status: 'ACTIVE',
        serviceUrl,
        webhookType,
      },
      pagination: {
        page: 0,
        size: 10,
      },
      callback: () => {
        history.push('/webhooks');
      },
    });
  };

  return (
    <div>
      <Typography variant="h6" component="h2">
        {`ایجاد وب هوک`}
      </Typography>
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <Grid>
              <Typography className={classes.typographyCards}>
                لیست وب‌هوک‌ها
              </Typography>
            </Grid>
          }
          action={<div className={classes.btnBox}></div>}
        />

        <CardContent className={classes.cardContentOrder}>
          <Grid container style={{ marginTop: '10px' }} spacing={3}>
            <Grid container item xs={12} sm={6} alignItems="flex-end">
              <div className={classes.item}>
                <span style={{ width: '100%' }}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      select
                      label=" نوع وب هوک"
                      variant="outlined"
                      fullWidth
                      id="webhookType"
                      name="webhookType"
                      inputProps={{
                        name: 'webhookType',
                        id: 'webhookType',
                      }}
                      value={webhookType}
                      onChange={e => setWebhookType(e.target.value)}
                    >
                      {webhookTypes.map((item: any) => {
                        return (
                          <MenuItem key={item} value={item}>
                            {translate(item)}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </FormControl>
                </span>
              </div>
            </Grid>
            <Grid container item xs={12} sm={6} alignItems="flex-end">
              <div className={classes.item}>
                <span style={{ width: '100%' }}>
                  <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    disabled={!webhookType}
                    id="webHookUrl"
                    label={'وب سرویس'}
                    name="webHookUrl"
                    value={serviceUrl}
                    onChange={e => setServiceUrl(e.target.value)}
                  />
                </span>
              </div>
            </Grid>
            {/* <Grid container item xs={12} sm={6} alignItems="center">
              <div className={classes.item}>
                <span className={classes.label}>
                  <Checkbox
                    checked={status === 'ACTIVE'}
                    onChange={handleCheck}
                    name={webhookType}
                  />
                </span>

                <span style={{width: '100%'}}>
                  {` وضعیت
                ( ${status === 'ACTIVE' ? 'فعال' : 'غیر فعال'} )`}
                </span>
              </div>
            </Grid> */}
          </Grid>
        </CardContent>
      </Card>
      <Grid
        container
        lg={12}
        md={12}
        xs={12}
        spacing={2}
        style={{
          flexDirection: 'row-reverse',
          position: 'fixed',
          backgroundColor: '#D5DADD',
          bottom: '0',
          right: '75px',
          padding: '15px',
          zIndex: 2,
        }}
      >
        <Grid
          container
          style={{
            marginTop: '-4px',
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="medium"
            onClick={() => window.history.back()}
            style={{
              marginRight: 'auto',
            }}
          >
            {'انصراف'}
          </Button>
          <Button
            type="button"
            size="medium"
            variant="contained"
            color="primary"
            disabled={props.loading || !serviceUrl}
            onClick={createWebhook}
            style={{
              marginRight: '14px',
              marginLeft: '120px',
            }}
          >
            {'ذخیره وب‌هوک'}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    createWebhooksDispatch: (payload: PayloadCreate) =>
      dispatch(createWebhooksActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(WebhookComponent);
